// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__735ar","header":"ReportDetails_header__3upBR","title":"ReportDetails_title__sliU9","left":"ReportDetails_left__yamOo"};